import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import type { TTopic } from '~services/api/topics/types';
import { api, apiTags } from '~shared/api/origin';
import { eventsInbox, EventType } from '~shared/services/eventsInbox';

export const usePremiumTopicReceived = (topics: TTopic[]) => {
	const dispatch = useDispatch();
	const [needRefresh, serRefresh] = useState(false);

	useEffect(
		() =>
			eventsInbox.onTypeMsg(EventType.ChatMessageReceived, (payload) => {
				const name = payload.meta?.automation?.topicName;

				if (topics.find((t) => t.Name === name)) {
					if (payload.meta?.reference) {
						serRefresh(true);
					}
				}

				if (needRefresh) {
					dispatch(api.util.invalidateTags([apiTags.premiumTopics]));
				}
			}),
		[dispatch, needRefresh, topics]
	);

	useEffect(() => {
		return () => {
			dispatch(api.util.invalidateTags([apiTags.premiumTopics]));
		};
	}, [dispatch]);
};
